export default {"src":"/_next/static/media/0xd17479997F34dd9156Deef8F95A52D81D265be9c.b2b8934a.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};